export default {
  show(cb) {
    document.getElementById("sk-circle").style.display  = "block";
	document.documentElement.style.overflow             = "scroll";
	document.getElementById("myDiv").style.pointerEvents= "none";
	document.getElementById("myDiv").style.opacity      = 0.3;
	document.documentElement.style.position 			= "fixed";
  },
  hide(cb) {     
	document.getElementById("sk-circle").style.display  = "none";
	document.getElementById("myDiv").style.pointerEvents= "auto";
	document.documentElement.style.overflow             = "auto";	
	document.getElementById("myDiv").style.opacity      = 1;
	document.documentElement.style.position 			= "relative";
  }
}